<template>
  <div class="tasks-container">
    <div class="operation-bar">
      <el-button type="primary" size="mini" @click="handleCreate">新增</el-button>
      <el-button type="danger" size="mini" @click="handleBatchDelete" :disabled="!selectedRows.length">删除</el-button>
      <div class="search-box">
        <el-select v-model="searchStatus" placeholder="状态" style="width: 200px" size="mini" clearable>
          <el-option label="启用" :value="1"></el-option>
          <el-option label="禁用" :value="0"></el-option>
        </el-select>
        <el-button icon="el-icon-search" style="margin-left: 10px" size="mini" type="primary" @click="handleSearch"
          >查询</el-button
        >
      </div>
    </div>
    <el-table :data="tableData" border style="width: 100%" height="60vh" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="序号" type="index" width="80" align="center"> </el-table-column>
      <el-table-column prop="categoryName" label="农事任务名称"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间"></el-table-column>
      <el-table-column prop="enabled" label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.enabled === 1 ? 'success' : 'info'">{{
            scope.row.enabled === 1 ? '启用' : '禁用'
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" style="color: #2680dd" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" style="color: #04ff9f" @click="handleView(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @close="handleDialogClose">
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="农事任务" prop="categoryName">
          <el-input v-model="formData.categoryName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="enabled">
          <el-switch v-model="formData.enabled" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
    <!-- 新增：查看详情弹窗 -->
    <el-dialog title="查看详情" :visible.sync="viewDialogVisible" width="400px">
      <div>
        <p>任务名称：{{ viewRow.categoryName }}</p>
        <p>状态：{{ viewRow.enabled === 1 ? '启用' : '禁用' }}</p>
        <p>更新时间：{{ viewRow.updateTime }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="viewDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/axios';
import { baseUrl } from '@/axios/baseUrl';

export default {
  name: 'TasksManagement',
  data() {
    return {
      tableData: [],
      selectedRows: [],
      searchStatus: '',
      page: 1,
      pageSize: 10,
      totalCount: 0,
      dialogVisible: false,
      dialogTitle: '新增任务',
      formData: {
        id: '',
        categoryName: '',
        enabled: 1,
      },
      isEdit: false,
      rules: {
        categoryName: [{ required: true, message: '请输入农事任务名称', trigger: 'blur' }],
      },
      // 新增：查看详情弹窗相关
      viewDialogVisible: false,
      viewRow: {},
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          enabled: this.searchStatus,
        };
        const res = await axios.post(baseUrl + '/api/basic/farming-category/list-page', params);
        if (res.code === 200) {
          this.tableData = res.data.list || [];
          this.totalCount = parseInt(res.data.totalCount) || 0;
        }
      } catch (error) {
        this.$message.error('获取任务分类失败');
      }
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSearch() {
      this.page = 1;
      this.fetchData();
    },
    handleCreate() {
      this.isEdit = false;
      this.dialogTitle = '新增任务';
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.resetFields();
      });
    },
    handleEdit(row) {
      this.isEdit = true;
      this.dialogTitle = '编辑任务';
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.resetFields();
        this.formData = { ...row };
      });
    },
    handleView(row) {
      // 改为 el-dialog 弹窗
      this.viewRow = { ...row };
      this.viewDialogVisible = true;
    },
    handleDialogClose() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.isEdit = false;
      this.formData = {
        id: '',
        categoryName: '',
        enabled: 1,
      };
    },
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          try {
            const url = this.isEdit ? '/api/basic/farming-category/edit' : '/api/basic/farming-category/add';
            const res = await axios.post(baseUrl + url, this.formData);
            if (res.code === 200) {
              this.$message.success(this.isEdit ? '更新成功' : '新增成功');
              this.dialogVisible = false;
              this.fetchData();
            }
          } catch (error) {}
        }
      });
    },
    async handleBatchDelete() {
      if (!this.selectedRows.length) return;
      try {
        await this.$confirm(`确认删除选中的 ${this.selectedRows.length} 个任务吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        const ids = this.selectedRows.map((row) => row.id);
        const res = await axios.post(baseUrl + '/api/basic/farming-category/delete-batch', ids);
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.fetchData();
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('批量删除失败');
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
  },
};
</script>

<style scoped lang="less">
.tasks-container {
  padding: 20px;

  .operation-bar {
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    .search-box {
      margin-left: auto;
    }
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
